'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroAccordion = require('./NitroAccordion');

var _NitroAccordion2 = _interopRequireDefault(_NitroAccordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroAccordion2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-accordion/index.js
// module id = 325
// module chunks = 4